
import AuthService from "../services/auth.service";
import useApi from "./useApi";
import useAuth from "./useAuth";
import { useNavigate } from "react-router-dom";
import { deactivateWebToken } from "../utils/webPushSync";

const useLogout = () => {
    const { auth, setAuth } = useAuth();
    const navigate = useNavigate();
    const api = useApi();
    const logout = async () => {
        if (auth?.accessToken) {
            try {
                await deactivateWebToken({ appName: "client", axios: api }).catch(() => {});
                await AuthService.logout(api)
            } catch (e) { }
        }
        setAuth({});
        localStorage.removeItem("accessToken");
        sessionStorage.removeItem('state');
        localStorage.clear();
        sessionStorage.clear();
        navigate("/login");

    }
    
    return logout;
}

export default useLogout
